import { Button, Chip } from '@mui/material';
import LocationMap from '../Location';
import Education from './Education';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { apiEndpoint } from '../../constants/api';
import { Link, useParams } from 'react-router-dom';
import UserDetailsCard from './UserDetailsCard';
import { Spinner } from 'flowbite-react';
import UserInfo from './UserInfo';
import SocialMediaLinks from './SocialMediaLinks';
import WorkAndExperience from './WorkAndExperience';
import GalleryBox from '../GalleryBox';
// import Video from '../Video';

export default function UserView() {
  const [userData, setUserData] = useState({});

  const [loading, setLoading] = useState(true);
  const { id } = useParams();

  const loadUserProfile = async () => {
    try {
      const { data } = await axios.get(apiEndpoint(`/user/full-profile/${id}`));
      if (data.length > 0) {
        setUserData(data[0]);
      }
    } catch (error) {
      console.error('Failed to load user profile data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUserProfile();
  }, []);

  if (loading) {
    // Show spinner while loading
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner size="xl" aria-label="Loading data" />
        <h1>Loading Data....</h1>
      </div>
    );
  }

  if (!userData || Object.keys(userData).length === 0) {
    // Show message if no user data is found
    return (
      <div className="flex justify-center items-center h-screen">
        <h1>No User Data Found</h1>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto p-6 space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-9">
        {/* Left section: Candidate Details */}
        <div className="col-span-2">
          {/* card */}
          <UserDetailsCard
            userData={userData}
            location={userData.geo_location}
            skills={userData.skills}
          />
          {/* card ends */}

          {/* about section */}
          {userData.description && (
            <div className="flex flex-col mb-7">
              <h3 className="text-3xl font-semibold mb-5">About Candidate</h3>
              <p className="text-[#77838F] mb-4">
                {userData.description || 'N/A'}
              </p>
            </div>
          )}
          {/* about section ends */}
          <hr />

          {/* education section */}
          {userData.education && userData.education.length > 0 && (
            <Education
              heading="Education"
              data={userData.education}
              color="#D93025"
            />
          )}
          {/* education section ends */}
          <hr />

          {/* Work and experience section */}
          {userData.experience && userData.experience.length > 0 && (
            <WorkAndExperience
              heading="Work & Experience"
              data={userData.experience}
              color="#769de6"
            />
          )}

          {/* Work and experience section ends */}

          <hr />

          {/* protfolio images */}
          {userData.photos && userData.photos.length > 0 && (
            <GalleryBox photos={userData.photos} />
          )}

          <hr />

          {/* video */}
          {/* {userData.videos && userData.videos.length > 0 && (
            <Video videos={userData.videos} />
          )} */}
        </div>
        {/* left section ends */}

        {/* right section starts */}
        <div className="space-y-7 pl-5">
          {/* information section */}
          <div className="bg-[#f5f7fc] rounded-xl shadow-sm p-6">
            <h3 className="text-lg font-semibold mb-4">Information</h3>
            <UserInfo userInfo={userData} />
            {/* <button className="w-full mt-6 py-2 text-blue-500 border border-blue-500 rounded-2xl hover:bg-blue-600 hover:text-white transition-colors">
              Private Message
            </button> */}
            <SocialMediaLinks urls={userData} />
          </div>

          {/* location section */}
          {userData.geo_location && userData.geo_location.length > 0 && (
            <div>
              <h3 className="text-lg font-semibold mb-4">Location</h3>
              <div className="w-full h-48 bg-gray-100 rounded-lg">
                {/* Map placeholder */}
                <LocationMap location={userData.geo_location[0]} />
              </div>
            </div>
          )}

          {/* Professtional Skills */}
          {userData.skills.length > 0 && (
            <div>
              <h3 className="text-lg font-semibold mb-4">
                Professional Skills
              </h3>
              <div className="flex flex-wrap gap-2">
                {userData.skills.map((skill) => (
                  <Chip
                    key={skill.skill_id}
                    label={skill.skill_name}
                    variant="outlined"
                    sx={{
                      paddingX: '10px',
                      paddingY: '5px',
                      cursor: 'pointer',
                    }}
                  />
                ))}
              </div>
            </div>
          )}

          {/* resumes */}
          {userData.resumes.length > 0 && (
            <div>
              <h3 className="text-lg font-semibold mb-4">Resume</h3>
              <div className="flex flex-wrap gap-2">
                {userData.resumes.slice(0, 3).map((resume) => (
                  <Link
                    key={resume.resume_id}
                    to={`https://filmconnx-production.s3.amazonaws.com/uploads/${resume.resume_filename}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button variant="contained" color="primary">
                      {resume.resume_name
                        ? resume.resume_name.charAt(0).toUpperCase() +
                          resume.resume_name.slice(1)
                        : 'Sample resume'}
                    </Button>
                  </Link>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
